import React from "react";
import anime from "animejs";
import "./App.css";
import { ArrowUpRight } from "react-feather";

export default function App() {
  const targetTranslateY = window.innerHeight - 35;

  const initializeDripAnimation = (selector, delayStart) => {
    anime({
      targets: selector,
      translateY: targetTranslateY,
      delay: anime.stagger(100, { start: delayStart }),
      loop: true,
      easing: "easeInCubic",
    });
  };

  React.useEffect(() => {
    const dripConfigs = [
      { selector: ".drip", delayStart: 50 },
      { selector: ".drip2", delayStart: 175 },
      { selector: ".drip3", delayStart: 500 },
      { selector: ".drip4", delayStart: 750 },
      { selector: ".drip5", delayStart: 1150 },
      { selector: ".drip6", delayStart: 200 },
      { selector: ".drip7", delayStart: 300 },
    ];

    dripConfigs.forEach(({ selector, delayStart }) => {
      initializeDripAnimation(selector, delayStart);
    });
  }, []);

  return (
    <div>
      <div className="parent">
        <div className="one"></div>
      </div>

      <div className="parent">
        <div className="two-left">
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} className={`drip drip${i + 1}`}></div>
          ))}
        </div>
        <div className="two-main">
          <h1 className="name">Username</h1>
          <div>Corporate SWE with indie game dev aspirations</div>
          <br />
          <div className="header">Games:</div>
          <div>
            <a
              className="link"
              target="_blank"
              rel="noreferrer noopener"
              href="google.com/"
            >
              <i className="titleText">Brick Game</i>
            </a>
            <ArrowUpRight size={16} />
          </div>
          <div>Released: Jan 2023</div>
          <div>
            <a
              className="link"
              target="_blank"
              rel="noreferrer noopener"
              href="https://github.com"
            >
              +1M unique visitors
            </a>
            <ArrowUpRight size={16} />
          </div>
          <br />
          <div>
            <a
              className="link"
              target="_blank"
              rel="noreferrer noopener"
              href="google.com/"
            >
              <i className="titleText">Art Game</i>
            </a>
            <ArrowUpRight size={16} />
          </div>
          <div>Released: Feb 2023</div>
          <div>
            <a
              className="link"
              target="_blank"
              rel="noreferrer noopener"
              href="https://github.com"
            >
              +1M unique visitors
            </a>
            <ArrowUpRight size={16} />
          </div>
          <br />
          <div className="header">Extras:</div>
          <div>
            <a
              className="link"
              target="_blank"
              rel="noreferrer noopener"
              href="https://github.com"
            >
              <i className="titleText">Personal Blog</i>
            </a>
            <ArrowUpRight size={16} />
          </div>
          <div>Mostly about game dev and web dev</div>
          <br />
          <div className="header">Links:</div>
          <div>
            <i>
              <a
                className="link"
                target="_blank"
                rel="noreferrer noopener"
                href="google.com"
              >
                Bluesky
              </a>
            </i>
            <ArrowUpRight size={16} />
          </div>
          <div>
            <i>
              <a
                className="link"
                target="_blank"
                rel="noreferrer noopener"
                href="google.com"
              >
                YouTube
              </a>
            </i>
            <ArrowUpRight size={16} />
          </div>
          <div>
            <i>
              <a
                className="link"
                target="_blank"
                rel="noreferrer noopener"
                href="google.com"
              >
                Twitch
              </a>
            </i>
            <ArrowUpRight size={16} />
          </div>
          <div>
            <i>
              <a
                className="link"
                target="_blank"
                rel="noreferrer noopener"
                href="https://github.com"
              >
                Github
              </a>
            </i>
            <ArrowUpRight size={16} />
          </div>
        </div>
      </div>
    </div>
  );
}
